import { init } from './init';

export { report } from './reporter';
export type { WixBi, ReportProps } from './types';

init();
